<template>
  <div class="c-aed-address">
    <div
      class="o-heading o-heading--bold o-heading--size-3 o-heading--section o-heading--border"
    >
      {{ translationsAddress.sectionName }}
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span
            class="o-label"
            :title="translationsAddress.organisation || ''"
            >{{ translationsAddress.organisation || "" }}</span
          >
        </div>
        <div class="o-grid__item o-grid__item--7">
          <CallCenterAEDeditableInput
            :section="section"
            name="organisation"
            :value="(address && address.organisation) || ''"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span class="o-label" :title="translationsAddress.category || ''">{{
            translationsAddress.category || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--7">
          <CallCenterAEDeditableDropdown
            :section="section"
            submit-name="category"
            mutable-name="id"
            :canSubmit="false"
            :initialValue="selectedCategory || translationsCustom.unavailiable"
            :options="addressCategories"
            :edit-state="editingLocality"
            :canCancel="false"
            @valueChange="setSelectedCategory($event)"
          ></CallCenterAEDeditableDropdown>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field  o-field--spacing-40"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span class="o-label" :title="translationsAddress.locality || ''">{{
            translationsAddress.locality || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--7">
          <CallCenterAEDeditableDropdown
            :section="section"
            submit-name="localityId"
            mutable-name="id"
            label="locality"
            :edit-state="editingLocality"
            :have-to-submit="true"
            :initialValue="selectedLocality || translationsCustom.unavailiable"
            :canSubmit="
              selectedCategory && selectedCategory.types ? true : false
            "
            :options="selectableLocalities || []"
            @valueReset="resetCategory()"
            @valueSave="editingLocality = false"
          ></CallCenterAEDeditableDropdown>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span class="o-label" :title="translationsAddress.street || ''">{{
            translationsAddress.street || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--7">
          <CallCenterAEDeditableInput
            :section="section"
            name="street"
            :canSubmit="false"
            :canCancel="false"
            :editState="editingAddress"
            v-model="mutableAddress.street"
            @editing="editingAddress = true"
            :required="true"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span class="o-label" :title="translationsAddress.number || ''">{{
            translationsAddress.number || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--7">
          <CallCenterAEDeditableInput
            :section="section"
            name="number"
            :canSubmit="false"
            :canCancel="false"
            :editState="editingAddress"
            @editing="editingAddress = true"
            v-model="mutableAddress.number"
            :required="true"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span class="o-label" :title="translationsAddress.floor || ''">{{
            translationsAddress.floor || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--7">
          <CallCenterAEDeditableInput
            :section="section"
            name="floor"
            :canSubmit="false"
            :canCancel="false"
            :editState="editingAddress"
            @editing="editingAddress = true"
            v-model="mutableAddress.floor"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span class="o-label" :title="translationsAddress.postalCode || ''">{{
            translationsAddress.postalCode || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--7">
          <CallCenterAEDeditableInput
            :section="section"
            name="postalCode"
            :canSubmit="false"
            :canCancel="false"
            :editState="editingAddress"
            @editing="editingAddress = true"
            v-model="mutableAddress.postalCode"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-40"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--5">
          <span class="o-label" :title="translationsAddress.city || ''">{{
            translationsAddress.city || ""
          }}</span>
        </div>
        <div class="o-grid__item o-grid__item--7">
          <CallCenterAEDeditableInput
            :section="section"
            name="city"
            :canSubmit="false"
            :canCancel="false"
            :editState="editingAddress"
            @editing="editingAddress = true"
            v-model="mutableAddress.city"
          ></CallCenterAEDeditableInput>
        </div>
      </div>
    </div>
    <transition name="o-transition__fade" mode="out-in">
      <div
        class="o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--justify-content-end o-field o-field--spacing-40"
        v-if="editingAddress"
      >
        <div class="o-grid__group">
          <div class="o-grid__item o-grid__item--grow-0">
            <button
              class="o-button o-button--small"
              :disabled="
                mutableAddress.street === '' || mutableAddress.number === ''
              "
              @click="updateCoordinates"
            >
              <svg
                class="o-svg-icon o-button__icon"
                viewBox="0 0 64 64"
                type="image/svg+xml"
              >
                <use
                  xlink:href="spritemap.svg#sprite-check-thinline"
                  x="0"
                  y="0"
                ></use>
              </svg>
              <span>{{
                translationsAddress.saveAndUpdatePlacement || ""
              }}</span>
            </button>
          </div>
          <div class="o-grid__item o-grid__item--grow-0">
            <button
              class="o-button o-button--small o-button--light o-button--shadow"
              @click="resetAddress"
            >
              <svg
                class="o-svg-icon o-button__icon"
                viewBox="0 0 64 64"
                type="image/svg+xml"
              >
                <use xlink:href="spritemap.svg#sprite-cross" x="0" y="0"></use>
              </svg>
              <span>{{ translationsCustom.cancel || "" }}</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
    <transition name="o-transition__fade" mode="out-in">
      <div
        class="c-aed-address__notication o-field o-field--spacing-20"
        v-if="showAddressUpdateMessage"
      >
        <div class="o-grid o-grid--direction-row o-grid--gutter-tiny">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <p class="c-aed-address__notication-text">
                {{
                  translationsAddress.placementChangedToNewAddressCoordinates
                }}
              </p>
              <p class="c-aed-address__notication-text">
                {{ translationsAddress.checkThatMarkerIsInExactPlace }}
              </p>
            </div>
            <div class="o-grid__item o-grid__item--grow-0">
              <button
                class="c-aed-address__notication-button o-button o-button--small o-button--light o-button--shadow"
                @click="showAddressUpdateMessage = false"
              >
                <span>{{ translationsCustom.ok || "" }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="o-transition__fade" mode="out-in">
      <div
        class="c-aed-address__notication o-field o-field--spacing-20"
        v-if="showLocationUpdateMessage"
      >
        <div class="o-grid o-grid--direction-row o-grid--gutter-tiny">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <p class="c-aed-address__notication-text">
                {{ translationsAddress.checkThatMarkerIsInExactPlace }}
              </p>
            </div>
            <div class="o-grid__item o-grid__item--grow-0">
              <button
                class="c-aed-address__notication-button o-button o-button--small o-button--light o-button--shadow"
                @click="resetAddressCoordinates"
              >
                <span>{{
                  translationsAddress.resetAddressCoordinates || ""
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import { mapState, mapGetters } from "vuex";
export default {
  name: "c-aed-address",
  data() {
    return {
      section: "address",
      name: "Address",
      mutableAddress: {},
      mutableLocation: {},
      selectedCategory: {},
      selectedLocality: {},
      editingLocality: false,
      editingAddress: false,
      showAddressUpdateMessage: false,
      showLocationUpdateMessage: false
    };
  },
  computed: {
    ...mapGetters("aed", ["parameters", "address", "placement"]),
    ...mapState("aeds", ["addressCategories"]),
    ...mapState("aed", ["loading"]),
    ...mapState("translations", {
      translationsAddress: "address",
      translationsCustom: "custom"
    }),
    google: gmapApi,
    selectableLocalities() {
      return this.selectedCategory.id !== 0 ? this.selectedCategory.types : [];
    }
  },
  methods: {
    updateCoordinates() {
      this.getCoordinatesFromAddressDataApi();
      this.editingAddress = false;
      this.showLocationUpdateMessage = false;
    },
    getCoordinatesFromAddressDataApi() {
      var url =
        this.$dawaUrl +
        "api/adresser?vejnavn=" +
        this.mutableAddress.street +
        "&husnr=" +
        this.mutableAddress.number.replace(
          /^[^0-9]*([0-9]+)\s*([a-zA-Z]?).*/g,
          "$1$2"
        ) +
        "&postnr=" +
        this.mutableAddress.postalCode;
      this.isApiResponsesuccessful = false;
      var request = new XMLHttpRequest();
      request.open("GET", url, false);
      request.onload = () => {
        var results = JSON.parse(request.response);
        if (request.status >= 200 && request.status < 400) {
          if (results[0]) {
            if (results[0].adgangsadresse.adgangspunkt.koordinater.length > 0) {
              this.mutableLocation.longitude =
                results[0].adgangsadresse.adgangspunkt.koordinater[0];
              this.mutableLocation.latitude =
                results[0].adgangsadresse.adgangspunkt.koordinater[1];
            } else {
              this.mutableLocation.longitude =
                results[0].adgangsadresse.vejpunkt.koordinater[0];
              this.mutableLocation.latitude =
                results[0].adgangsadresse.vejpunkt.koordinater[1];
            }
            this.mutableAddress.MunicipalityId =
              results[0].adgangsadresse.kommune.kode;
            this.updateCoordinatesFromApi();
          } else {
            window.alert("No results found"); //TODO
          }
        } else {
          window.alert("Request failed"); //TODO
        }
      };
      request.send();
    },
    updateCoordinatesFromApi() {
      this.submitCoordinates();
      this.submitAddress();
      this.showAddressUpdateMessage = true;
    },
    submitCoordinates() {
      let payload = {
        api: this.$api,
        id: this.$store.state.aed.all.id,
        section: "placement",
        method: "PATCH",
        data: this.mutableLocation
      };
      // payload.data[this.name] = this.mutableValue;

      this.$store.dispatch("aed/setSection", payload);
    },
    submitAddress() {
      let payload = {
        api: this.$api,
        id: this.$store.state.aed.all.id,
        section: this.section,
        method: "PATCH",
        data: this.mutableAddress
      };
      // payload.data[this.name] = this.mutableValue;

      this.$store.dispatch("aed/setSection", payload);
    },
    setSelectedCategory(value) {
      this.selectedCategory = value;
      this.editingLocality = true;
      this.canCancelLocalityEdit = false;
      this.selectedLocality = [];
    },
    setInitialCategory() {
      this.selectedCategory =
        this.addressCategories.find(
          category => category.id === this.address.categoryId
        ) || this.address.category;
      this.selectedLocality = this.selectedCategory
        ? this.selectedCategory.types.find(
            locality => locality.id === this.address.localityId
          ) || this.address.locality
        : this.address.locality;
    },
    resetCategory() {
      this.setInitialCategory();
      this.editingLocality = false;
    },
    resetAddress() {
      this.mutableAddress = {
        street: this.address.street,
        number: this.address.number,
        floor: this.address.floor,
        postalCode: this.address.postalCode,
        city: this.address.city
      };
      this.editingAddress = false;
    },
    resetAddressCoordinates() {
      this.submitCoordinates();
      this.showLocationUpdateMessage = false;
    }
  },
  created() {
    this.setInitialCategory();
    this.mutableAddress = {
      street: this.address.street,
      number: this.address.number,
      floor: this.address.floor,
      postalCode: this.address.postalCode,
      city: this.address.city
    };
    this.mutableLocation = {
      latitude: this.placement.latitude,
      longitude: this.placement.longitude
    };
  },
  watch: {
    placement: {
      handler: function(newValue) {
        const changedLatitude =
          this.mutableLocation.latitude !== newValue.latitude;
        const changedLongitude =
          this.mutableLocation.longitude !== newValue.longitude;
        this.showLocationUpdateMessage = changedLatitude || changedLongitude;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.c-aed-address {
  &__notication {
    background-color: $s-cp-neutral-800;
    padding: toRem(20px 20px 30px);
    @include setStyles("14", $s-typography-sizes);
  }
  &__notication-text {
    @include setStyles("14", $s-typography-sizes);
    color: $s-cp-neutral-300;
  }
  &__notication-button {
    color: $s-cp-sup-blue;
    font-weight: 700;
  }
}
</style>
